/* eslint-disable */

/* jshint maxcomplexity:12, maxstatements:40 */
function optionSelect(
  ControlId,
  CatId,
  SkuId,
  ParentId,
  RelId,
  RelType,
  FullPrice,
  Price,
  ParentRelId
) {
  var wasContainer = ".total-col1 .was-price";
  var priceContainer = ".total-col2 .price";

  var wasContainerSide = ".polytunnel-price-inner .was-price";
  var priceContainerSide = ".polytunnel-price-inner .price";

  var currentWasTotal = parseFloat(
    $(wasContainer)
      .html()
      .replace("£", "")
      .replace("&pound;", "")
      .replace(",", "")
  );
  var currentTotal = parseFloat(
    $(priceContainer)
      .html()
      .replace("£", "")
      .replace("&pound;", "")
      .replace(",", "")
  );
  var wasPrice = parseFloat(FullPrice);
  var price = parseFloat(Price);
  var newWasTotal = 0;
  var newTotal = 0;

  var relatedHasDefault = false;

  // Does this item relationship have a default selection
  $("input[type=checkbox]").each(function() {
    var $this = $(this);
    if (
      parseInt($this.attr("data-rel")) > 0 &&
      $this.attr("data-rel") === String(RelId) &&
      $this.attr("data-standard") === "Y"
    ) {
      relatedHasDefault = true;
    }
  });

  var requiredParentId = null;
  var isNoDoorsCheckbox = false;

  if ($("#" + ControlId).siblings("p").length > 0) {
    var itemName = $("#" + ControlId)
      .siblings("p")
      .html();
    if (itemName.toLowerCase().indexOf("no doors and frames") !== -1) {
      isNoDoorsCheckbox = true;
    }
  }

  // if this not checked
  if (!$("#" + ControlId).is(":checked")) {
    // loop through checkboxes
    $("input[type=checkbox]").each(function() {
      var $this = $(this);
      // if a child option
      if (
        (parseInt($this.attr("data-parent")) > 0 &&
          $this.attr("data-parent") === String(SkuId)) ||
        (parseInt($this.attr("data-parent-rel")) > 0 &&
          $this.attr("data-parent-rel") === String(RelId))
      ) {
        // if checked remove price from total
        if ($this.is(":checked")) {
          wasPrice += parseFloat($this.attr("data-was-price"));
          price += parseFloat($this.attr("data-price"));
        }
        // disable child option
        $this.prop("checked", false);
        $this.attr("disabled", "disabled");
        $this.attr("data-disable", "par");
        $this.closest(".optional-inner-row").addClass("struck-out");
        $this.closest(".optional-inner-row").removeClass("active-row");
      }
      // if related
      else if (
        parseInt($this.attr("data-rel")) > 0 &&
        $this.attr("data-rel") === String(RelId)
      ) {
        $this.removeAttr("disabled");
        $this.attr("data-disable", "");
        $this.attr("data-related", "");
        $this.closest(".optional-inner-row").removeClass("struck-out");
      }
      // if no doors and user unselected select first front and rear door
      else if (
        isNoDoorsCheckbox &&
        RelType.indexOf($this.attr("data-rel")) !== -1
      ) {
        var arrRelIds = RelType.split("|");

        if (
          $this.attr("id") ===
            $("input[data-rel=" + arrRelIds[0] + "]:first").attr("id") &&
          $this.attr("data-price") === "0"
        ) {
          $this.prop("checked", true);
          $this.closest(".optional-inner-row").addClass("active-row");
        }
        if (arrRelIds[1] !== undefined) {
          if (
            $this.attr("id") ===
              $("input[data-rel=" + arrRelIds[1] + "]:first").attr("id") &&
            $this.attr("data-price") === "0"
          ) {
            $this.prop("checked", true);
            $this.closest(".optional-inner-row").addClass("active-row");
          }
        }
      }

      // add attr to parent for selected child option
      if (
        (parseInt(ParentId) > 0 && $this.attr("value") === String(ParentId)) ||
        (parseInt(ParentRelId) > 0 &&
          $this.attr("data-rel") === String(ParentRelId))
      ) {
        $this.removeAttr("disabled");
        $this.removeAttr("data-child");
      }
    });

    // new totals
    newWasTotal = currentWasTotal - wasPrice;
    newTotal = currentTotal - price;
  }
  // if checked
  else {
    // loop through checkboxes
    $("input[type=checkbox]").each(function() {
      var $this = $(this);
      // if a child option
      if (
        (parseInt($this.attr("data-parent")) > 0 &&
          $this.attr("data-parent") === String(SkuId)) ||
        (parseInt($this.attr("data-parent-rel")) > 0 &&
          $this.attr("data-parent-rel") === String(RelId))
      ) {
        // enable child option
        $this.removeAttr("disabled");
        $this.attr("data-disable", "");
        $this.closest(".optional-inner-row").removeClass("struck-out");

        requiredParentId = $this.attr("id");
      }
      // if related and has standard do not show message but remove other selected items (and not additions)
      else if (
        $this.attr("value") !== String(SkuId) &&
        $this.attr("data-rel") === String(RelId) &&
        RelType === "OR" &&
        relatedHasDefault &&
        $this
          .closest(".optional-inner")
          .children(".optional-inner-top")
          .children("h3")
          .html()
          .toLowerCase()
          .indexOf("additions") === -1
      ) {
        if ($this.is(":checked")) {
          wasPrice -= parseFloat($this.attr("data-was-price"));
          price -= parseFloat($this.attr("data-price"));

          newWasTotal = currentWasTotal - wasPrice;
          newTotal = currentTotal - price;

          $this.closest(".optional-inner-row").removeClass("active-row");
          $this.prop("checked", false);
        }
        $this.attr("data-disable", "rel");
        $this.attr("data-related", ControlId);
      }
      // if related by OR disable
      else if (
        $this.attr("value") !== String(SkuId) &&
        !$this.is(":checked") &&
        $this.attr("data-rel") === String(RelId) &&
        RelType === "OR"
      ) {
        $this.attr("disabled", "disabled");
        $this.attr("data-disable", "rel");
        $this.attr("data-related", ControlId);
        $this.closest(".optional-inner-row").addClass("struck-out");
      }
      // if a door and user selected no doors
      else if (
        isNoDoorsCheckbox &&
        RelType.indexOf($this.attr("data-rel")) !== -1
      ) {
        if ($this.is(":checked")) {
          wasPrice -= parseFloat($this.attr("data-was-price"));
          price -= parseFloat($this.attr("data-price"));

          newWasTotal = currentWasTotal - wasPrice;
          newTotal = currentTotal - price;

          $this.closest(".optional-inner-row").removeClass("active-row");
          $this.prop("checked", false);
        }
      }
      // if no doors and user selected a door
      else if (
        typeof $this.attr("data-rel-type") !== "undefined" &&
        $this.attr("data-rel-type") !== "false"
      ) {
        if (
          $this.attr("data-rel-type").indexOf(RelId) !== -1 &&
          $this.is(":checked")
        ) {
          wasPrice -= parseFloat($this.attr("data-was-price"));
          price -= parseFloat($this.attr("data-price"));

          newWasTotal = currentWasTotal - wasPrice;
          newTotal = currentTotal - price;

          $this.closest(".optional-inner-row").removeClass("active-row");
          $this.prop("checked", false);
        }
      }

      // add attr to parent for selected child option
      if (
        (parseInt(ParentId) > 0 && $this.attr("value") === String(ParentId)) ||
        (parseInt(ParentRelId) > 0 &&
          $this.attr("data-rel") === String(ParentRelId))
      ) {
        $this.attr("disabled", "disabled");
        $this.attr("data-child", ControlId);
      }
    });

    $("input[type=radio]").each(function() {
      var $this = $(this);
      // look for previous selected item and remove price
      // this is no longer needed with postback
      //if ($this.attr('data-length') == '1' && $this.attr('data-rel') == RelId) {
      //    $this.attr('data-length', '0');
      //    currentWasTotal -= parseFloat($this.attr('data-was-price'));
      //    currentTotal -= parseFloat($this.attr('data-price'));
      //}

      // uncheck all but item selected
      if (
        $this.attr("id") !== ControlId &&
        $this.is(":checked") &&
        $this.attr("data-rel") === String(RelId) &&
        RelType === "OR"
      ) {
        $this.prop("checked", false);
      }
      // mark new selected item
      else if ($this.attr("id") === ControlId) {
        $this.attr("data-length", "1");
      }
    });

    // new totals
    newWasTotal = currentWasTotal + wasPrice;
    newTotal = currentTotal + price;
  }

  // Update the kentico fields
  setTimeout(function() {
    $(
      ".CartItemSelector input[type=checkbox], .CartItemSelector input[type=radio]"
    ).each(function() {
      var $this = $(this);
      if ($this.val() !== undefined) {
        // find custom input which is related to Kentico's
        var $customInput = $(".optional-step input[value=" + $this.val() + "]");
        if ($customInput.val() !== undefined) {
          // set Kentico field checked status from custom input
          if ($customInput.is(":checked")) {
            $this.prop("checked", true);
          } else {
            $this.prop("checked", false);
          }
        }
      }
    });
  }, 100);

  // Update select length on add to cart
  $(".product-details input[type=submit]").click(function() {
    var selectedLength = 0;

    $(".select-length input[type=radio]").each(function() {
      if ($(this).is(":checked")) {
        selectedLength = $(this).val();
      }
    });

    $(".CartItemSelector input[type=radio][value=" + selectedLength + "]").prop(
      "checked",
      true
    );
  });

  // Update select length on add to cart
  $(".product-details input[type=submit]").click(function() {
    var selectedLength = 0;

    $(".select-length input[type=radio]").each(function() {
      if ($(this).is(":checked")) {
        selectedLength = $(this).val();
      }
    });

    $(".CartItemSelector input[type=radio][value=" + selectedLength + "]").prop(
      "checked",
      true
    );
  });

  // update totals
  if (newTotal < newWasTotal) {
    $(wasContainer).html("&pound;" + newWasTotal.formatMoney(2));
    if ($(wasContainerSide).length > 0) {
      $(wasContainerSide).html("&pound;" + newWasTotal.formatMoney(2));
    }
  } else {
    $(wasContainer).html("-");
    if ($(wasContainerSide).length > 0) {
      $(wasContainerSide).html("-");
    }
  }

  // Update select length on add to cart
  $(".product-details input[type=submit]").click(function() {
    var selectedLength = 0;

    $(".select-length input[type=radio]").each(function() {
      if ($(this).is(":checked")) {
        selectedLength = $(this).val();
      }
    });

    $(".CartItemSelector input[type=radio][value=" + selectedLength + "]").prop(
      "checked",
      true
    );
  });

  $(priceContainer).html("&pound;" + newTotal.formatMoney(2));
  $(priceContainerSide).html("&pound;" + newTotal.formatMoney(2));
}

/* jshint ignore:start */
Number.prototype.formatMoney = function(c, d, t) {
  var n = this,
    c = isNaN((c = Math.abs(c))) ? 2 : c,
    d = d === undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt((n = Math.abs(+n || 0).toFixed(c))) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return (
    s +
    (j ? i.substr(0, j) + t : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
    (c
      ? d +
        Math.abs(n - i)
          .toFixed(c)
          .slice(2)
      : "")
  );
};
/* jshint ignore:end */

// Expose on global scope because evil.
window.optionSelect = optionSelect;
module.exports = optionSelect;
